var p = {
  appId: {
    package: "cn.gov.pbc.dcep",
    scheme: "dcep://uniwallet/startApp",
    commonLink: "dcep://uniwallet/startApp/commonLink?uniwallet_biz=main"
  },
  jumpToAppAndriodScheme: "dcep://uniwallet",
  downloadUrl: {
    iosUrl: "itms-apps://itunes.apple.com/us/app/apple-store/id1571652872",
    androidUrl: "https://pilot.app.ecny.pbcdci.cn/download/index.html?disableAppStoreDefaultPage=1",
    androidMarket: "market://details?id=cn.gov.pbc.dcep"
  },
  bindWalletScheme: "dcep://uniwallet/startApp"
};
export { p as dcepAppConfig };
